import React from 'react';
import { Link } from 'react-router-dom';

interface IPost {
  route: string;
  textColor: string;
  backgroundColor: string;
  title: string;
  imageUrl: string;
  imageAlt: string;
  btnText: string;
}

interface IGuidePostProps {
  posts: IPost[];
}

const GuidePost = (props: IGuidePostProps) => {

  const { posts } = props;

  if (posts.length < 1) return null;

  return (
    <section className="row row-guidepost">
      <div className="container">
        <div className="row">
          {
            posts.map((post: IPost) => {
              return (
                <div className="col">
                  <Link 
                    to={post.route} 
                    className="guidepost" 
                    style={{
                      backgroundColor: `${post.backgroundColor}`,
                      color: `${post.textColor}`
                    }}
                  >
                    <p
                      className="text"
                      style={{color: `${post.textColor}`}}
                    >
                      {post.title}
                    </p>
                    <img src={post.imageUrl} className="ico" alt={post.imageAlt} />
                    <div className="relative-wrap">
                      <span className="btn btn-default">
                        {post.btnText}
                      </span>
                    </div>
                  </Link>
                </div>
              );
            })
          }
        </div>
      </div>
    </section>
  );
}

export default GuidePost;